<template>
  <div class="schedule">
    <top :title="nav_title" :color="theme_color"></top>
    <van-search v-model="keywords" placeholder="请输入搜索关键词" @search="onSearch" shape="round" background="#f7f7f7">
      <template #right-icon>
        <div @click="onSearch" class="search-icon">搜索</div>
      </template>
    </van-search>
    <div class="timeTabs-wrap2">
      <div class="timeTabs2">
        <div class="tab-item2" v-for="(item, index) in scheduleDate" :key="index" @click="switchDate(item)"
          :class="item == active ? 'active' : ''" :style="{
            background: item == active && theme_color ? theme_color : ''
          }">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="content">
      <ul class="leftC">
        <li class="item" v-for="(item, index) in scheduleList" :key="index"
          :style="{ background: theme_color ? theme_color : '' }" @click="hallSessionDetail(item)">
          <p v-html="formatTitle(
            item.daily_preview_title ? item.daily_preview_title : item.name
          )
            "></p>
          <p v-if="item.hall_name" v-html="formatTitle(item.hall_name ? item.hall_name : '')" style="font-size: 12px;">
          </p>
          <p class="lookAll">点击查看完整日程</p>
        </li>
      </ul>
      <div class="rightC">
        <div class="sessionList">
          <div class="list" v-for="(value, index) in scheduleList" :key="index">
            <router-link v-if="val.is_show_live" class="item" v-for="(val, ind) in value.chapters" :key="ind" :to="{
              path: '/vascularNews/meeting/scheduleList',
              query: {
                meeting_id: meeting_id,
                id: val.parallel_session_id,
                chapter_id: val.id,
                button_id: button_id
              }
            }" style="background:#ffffff">
              <h1 :class="meeting_id == 473 ? 'sp_theme_color' : ''" :style="{
                background: val.id == 7937 ? theme_color : schedule_color ? schedule_color : '',
                color: val.id == 7937 ? '#fff' : schedule_font_color ? schedule_font_color : ''
              }">
                {{ val.start_at }}-{{ val.end_at }}
              </h1>
              <div :style="{
                background: val.id == 7937 ? theme_color : '#fff'
              }">
                <img :src="val.daily_preview_img" v-if="val.daily_preview_img" />
                <p class="line-clamp-5" v-else v-html="formatTitle(val.name)" :style="{
                  color: val.id == 7937 ? '#fff' : ''
                }"></p>
              </div>
              <!-- <img :src="val.daily_preview_img"> -->
            </router-link>
            <div style="width:10px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { MeetingsSchedule, ButtonDetail } from "../../../config/interface.js";
import Top from "../components/Top";

export default {
  components: {
    Top
  },
  data() {
    return {
      meeting_id: 0,
      button_id: this.$route.query.button_id
        ? this.$route.query.button_id
        : this.$route.query.b_id,
      active: 0,
      meetingSchedule: [], //会议日程
      scheduleDate: [], //会议日期
      scheduleList: [], //日期对应的日程列表
      img_src: "",
      theme_color: "",
      schedule_color: "",
      schedule_font_color: "",
      showTop: false,
      keywords: "",
      showSeachResult: false,
      nav_title: "日程一览",
      color: "#FFFFFF",
      details:{}
    };
  },
  mounted() {
    this.meeting_id = this.$route.query.id;
    this.getSchedule();
  },


  methods: {
    getSchedule() {
      const url = MeetingsSchedule;
      let params = {
        meeting_id: this.meeting_id
      };
      const method = "POST";
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          var data = res.data;
          this.meetingSchedule = data.sessions;
          this.img_src = data.meeting.schedule_center_img;
          document.title = data.meeting.name;
          this.details=data.meeting
          if (data.meeting.theme_color_hex) {
            this.theme_color = data.meeting.theme_color_hex;
          } else {
            this.theme_color = "#901D22";
          }

          if (data.meeting.schedule_color_hex) {
            this.schedule_color = data.meeting.schedule_color_hex;
          }
          if (data.meeting.schedule_font_color_hex) {
            this.schedule_font_color = data.meeting.schedule_font_color_hex;
          }
          console.log('schedule_font_color', this.schedule_font_color)
          this.scheduleDate = Object.keys(this.meetingSchedule).sort();
          // this.scheduleDate = Object.getOwnPropertyNames(this.meetingSchedule);
          for (var i in this.meetingSchedule) {
            this.meetingSchedule[i].forEach((item, suffix) => {
              item.chapters.forEach((value, index) => {
                value.start_at = this.handleDate(value.start_at);
                value.end_at = this.handleDate(value.end_at);
              });
              item["show"] = false;
            });
          }
          let today = this.getToday();
          let save_date = localStorage.getItem('schedule_date')
          if (this.scheduleDate.indexOf(today) > -1) {
            let index = this.scheduleDate.indexOf(today);
            this.switchDate(this.scheduleDate[index]);
          } else if (this.scheduleDate.indexOf(save_date) > -1) {
            let index = this.scheduleDate.indexOf(save_date);
            this.switchDate(this.scheduleDate[index]);
          }
          else {
            this.switchDate(this.scheduleDate[0]);
          }
          if (this.button_id) {
            this.getButtonData();
          } else if (common.is_weixin()) {
            common.wxShare(
              data.meeting.name,
              data.meeting.title,
              data.meeting.shareimg
            );
          }
        }
      });
    },
    //获取按钮信息
    getButtonData() {
      if (this.button_id) {
        const url = ButtonDetail;
        let params = {
          button_id: this.button_id
        };
        const method = "POST";
        fetch(url, params, method).then(res => {
          if (res.code == 0) {
            this.nav_title = res.data.name;
            // if (res.data.theme_color_hex) {
            //   this.color = res.data.theme_color_hex
            // } else {
            //   this.color = '#901D22'
            // }
            // if (!this.theme_color) {
            //   this.theme_color = res.data.top_color;
            // }
            if (common.is_weixin()) {
              let data = res.data;
              common.wxShare(
                data.share_title,
                this.details.name,
                data.share_img
              );
            }
          }
        });
      }
    },
    getToday() {
      let date = new Date();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let str = month + "月" + day + "日";
      // console.log(str);
      return str;
    },
    //切换日期
    switchDate(date) {
      this.scheduleList = this.meetingSchedule[date];
      // if(localStorage.getItem('schedule_date')&& !this.active){
      //    this.active=localStorage.getItem('schedule_date')
      // }else{
      this.active = date;
      // }
      localStorage.setItem("schedule_date", date);
    },
    //处理日期  09:30样式
    handleDate(date) {
      let time = date.split(" ")[1].split(":");
      return time[0] + ":" + time[1];
    },
    formatTitle(title) {
      let strs = title.split(" ") || title.split(" ");
      let str = "";
      for (let i = 0; i < strs.length; i++) {
        str = str + strs[i] + "<br/>";
      }
      return str;
    },
    onSearch() {
      if (this.keywords) {
        this.$router.push({
          path: "/vascularnews/schedule/result",
          query: {
            id: this.meeting_id,
            button_id: this.button_id,
            keywords: this.keywords
          }
        });
      }
    },
    hallSessionDetail(item) {
      this.$router.push({
        path: "/vascularnews/meeting/scheduleList",
        query: {
          meeting_id: this.meeting_id,
          id: item.id,
          button_id: this.button_id
        
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.schedule {
  display: flex;
  flex-direction: column;
  height: 100vh;

  .header-img {
    img {
      width: 100%;
      display: block;
    }

    // height: 70px;
  }

  .van-search /deep/.van-field__right-icon {
    color: #666666;
    background: #ebebeb;
    border-radius: 15px;
    margin-right: 5px;
    width: 60px;
    text-align: center;
  }

  .timeTabs2 {
    padding: 0px 12px 5px;
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;

    .tab-item2 {
      display: inline-block;
      font-size: 14px;
      color: #666666;
      width: 90px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      border-radius: 5px;
      margin: 5px 15px 5px 0;
      background: #ffffff;
      cursor: pointer;
    }

    .active {
      color: #fff;
      background: #901d22;
    }
  }

  .content {
    padding: 0px 0 10px 10px;
    // background-color: #f1f2f4;
    flex: 1;
    overflow: scroll;

    .leftC {
      float: left;
      width: 90px;

      .item {
        // display: -webkit-box;
        box-sizing: border-box;
        width: 90px;
        background: #901d22;
        color: white;
        border-radius: 3px;
        height: 120px;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 14px;
        // letter-spacing: 0.5px;
        margin-bottom: 10px;
        text-align: center;
        border-radius: 10px;
        padding: 0 10px;
        flex-direction: column;
        display: flex;

        img {
          height: 100%;
        }
      }
    }

    .rightC {
      overflow-x: auto;
      float: left;
      width: calc(100% - 90px);
      padding-left: 10px;

      .list {
        display: -webkit-box;
        // margin-left: 5px;
        // margin-right: 5px;
        // white-space: nowrap;
        // margin-bottom: 0.32rem;
      }

      .item {
        display: block;
        box-sizing: border-box;
        background: #901d22;
        border-radius: 3px;
        width: 120px;
        height: 120px;
        margin-right: 10px;
        margin-bottom: 10px;
        text-align: center;
        border-radius: 10px;
        overflow: hidden;

        img {
          width: 100%;
        }

        h1 {
          font-weight: normal;
          text-align: center;
          font-size: 12px;
          line-height: 34px;
          color: #901d22;
          background: linear-gradient(90deg, #ffe6e7 0%, #fff1f1 100%);
          letter-spacing: 0.42px;
        }

        div {
          padding: 5px 10px;
          border-radius: 3px;
          background: #fff;
          height: 85px;
          display: flex;
          align-items: center;
          justify-content: center;

          p {
            word-break: break-all;
            font-size: 12px;
            color: black;
            letter-spacing: 0.42px;
            white-space: pre-wrap;
          }
        }
      }
    }
  }

  .content:after {
    display: block;
    content: "";
    clear: both;
  }
}

.van-search__content {
  background: white;
}

.sp_theme_color {
  background-color: #0a318e !important;
  color: #0a318e;
}

.lookAll {
  padding: 2px 4px;
  background: rgba($color: #fff, $alpha: 0.2);
  color: #fff;
  font-size: 8px;
  font-weight: 400;
  // line-height: 24px;
  white-space: nowrap;
  cursor: pointer;
  margin-top: 10px;
}
</style>
<style>
/* @media screen and (min-width:580px) {
  #app {
    max-width: 90% !important;
  }
} */

@media screen and (min-width:1000px) {
  .schedule .content .rightC .item {
    width: 160px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/Schedule.vue